import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "calendar-container mb-5"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 1,
  class: "progress"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "progress-bar progress-bar-striped progress-bar-animated",
  role: "progressbar",
  "aria-valuenow": "100",
  "aria-valuemin": "0",
  "aria-valuemax": "100",
  style: {"width":"100%"}
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.contentDataLoaded)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_router_view, { name: "dayNavigation" }),
          _createElementVNode("div", {
            class: "hidden-calendar-daily",
            innerHTML: _ctx.monthlyLeadIn
          }, null, 8, _hoisted_2),
          _createElementVNode("div", {
            class: "hidden-calendar-monthly",
            innerHTML: _ctx.dailyLeadIn
          }, null, 8, _hoisted_3),
          _createVNode(_component_router_view, { onDataLoaded: _ctx.onChildDataLoaded }, null, 8, ["onDataLoaded"])
        ], 512)), [
          [_vShow, _ctx.childDataLoaded]
        ])
      : _createCommentVNode("", true),
    (!(_ctx.contentDataLoaded && _ctx.childDataLoaded))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
      : _createCommentVNode("", true)
  ], 64))
}